import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthSignalService } from '../../core/state/auth.signal';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-link-zoho',
  templateUrl: './link-zoho.component.html',
  styleUrls: ['./link-zoho.component.css'],
  standalone: false
})
export class LinkZohoComponent implements OnInit, OnDestroy {
  loading = false;
  errorMessage = '';

  private messageListener = (event: MessageEvent) => {
    // Escucha mensajes del popup de Zoho para sincronizar estado
    if (event.origin !== window.location.origin) return;
    
    if (event.data?.type === 'ZOHO_LINKED') {
       this.authSignal.setZohoLinked(true);
       this.router.navigate(['/inbox']);
    } else if (event.data?.type === 'ZOHO_LINK_ERROR') {
       this.errorMessage = event.data.error;
       this.loading = false;
    }
  };

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private authSignal: AuthSignalService
  ) {}

  ngOnInit() {
    window.addEventListener('message', this.messageListener);

    this.route.queryParams.subscribe(params => {
      // Si estamos dentro del popup, notificamos al padre y cerramos
      if (window.opener && window.opener !== window) {
         if (params['zoho_linked'] === 'true') {
            window.opener.postMessage({ type: 'ZOHO_LINKED', status: 'success' }, window.location.origin);
            window.close();
            return;
         }
         if (params['error']) {
            window.opener.postMessage({ type: 'ZOHO_LINK_ERROR', error: params['error'] }, window.location.origin);
            window.close();
            return;
         }
      }

      if (params['zoho_linked'] === 'true') {
         this.authSignal.setZohoLinked(true);
         this.router.navigate(['/inbox']); // Redirect immediately to inbox if successful
      }
      if (params['error']) {
         this.errorMessage = params['error'];
      }
    });

    // Validar si mágicamente ya está conectado o vuelve al login/dashboard
    const user = this.authSignal.user();
    if (user?.zohoLinked) {
        this.router.navigate(['/inbox']);
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageListener);
  }

  linkZoho() {
    this.loading = true;
    this.errorMessage = '';
    const returnUrl = '/link-zoho'; // Para que el backend redirija a esta misma ruta para Angular

    this.http.get<{url: string}>(`${environment.apiUrl}/zoho/auth-url?returnUrl=${returnUrl}`).subscribe({
      next: (res) => {
        // Abrir en ventana emergente (popup) o nueva pestaña en vez del mismo Iframe.
        // Esto evita el bloqueo de iframe por parte de accounts.zoho.com (X-Frame-Options: SAMEORIGIN)
        const width = 600;
        const height = 700;
        // Calculamos la posición del popup
        const left = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
        const top = window.screenTop !== undefined ? window.screenTop : window.screenY;
        const popupX = left + ((window.innerWidth || document.documentElement.clientWidth) - width) / 2;
        const popupY = top + ((window.innerHeight || document.documentElement.clientHeight) - height) / 2;

        const authWindow = window.open(res.url, 'zohoAuth', `width=${width},height=${height},left=${popupX},top=${popupY}`);

        if (!authWindow) {
            this.errorMessage = 'El navegador bloqueó la ventana emergente. Por favor, permite las ventanas emergentes y vuelve a intentarlo.';
            this.loading = false;
        } else {
            // Revisar periódicamente si el usuario cerró el popup a la fuerza
            const timer = setInterval(() => {
                if (authWindow.closed) {
                    clearInterval(timer);
                    if (this.loading) { // Si aún decía loading es porque no terminó el flujo correcto
                        this.loading = false;
                    }
                }
            }, 500);
        }
      },
      error: (err) => {
        this.errorMessage = 'Ocurrió un error al contactar al backend para obtener el permiso.';
        this.loading = false;
      }
    });
  }
}
